import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/seoContent';

const articleCards = [
  {
    slug: 'hipobuy-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20pairs%20of%20designer%20sneakers%20arranged%20on%20floating%20white%20pedestals%20with%20soft%20directional%20studio%20lighting%2C%20cream%20background%2C%20luxury%20product%20showcase%20photography%2C%20warm%20caramel%20and%20sand%20tones%2C%20minimalist%20artistic%20composition%20with%20dramatic%20shadows&width=800&height=480&seq=seocard-v2-guide-main&orientation=landscape',
  },
  {
    slug: 'hipobuy-vs-kakobuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20distinct%20sneaker%20styles%20displayed%20side%20by%20side%20on%20split%20tone%20background%2C%20one%20minimalist%20white%20sneaker%20and%20one%20bold%20colorway%2C%20comparison%20product%20photography%2C%20warm%20beige%20and%20terracotta%20palette%2C%20editorial%20studio%20lighting%2C%20clean%20modern%20aesthetic&width=800&height=480&seq=seocard-v2-vs-kakobuy&orientation=landscape',
  },
  {
    slug: 'best-sneaker-spreadsheets',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20sneaker%20collection%20displayed%20on%20tiered%20wooden%20shelving%20unit%2C%20various%20colorways%20and%20brands%2C%20warm%20gallery%20lighting%20from%20above%2C%20collector%20showcase%20photography%2C%20rich%20oak%20and%20cream%20tones%2C%20organized%20luxury%20display%20aesthetic&width=800&height=480&seq=seocard-v2-sneaker-collect&orientation=landscape',
  },
  {
    slug: 'find-cheapest-products',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20accessories%20flat%20lay%20with%20leather%20wallet%2C%20canvas%20tote%2C%20sunglasses%20and%20watch%20arranged%20with%20vintage%20price%20tags%2C%20soft%20window%20light%2C%20smart%20shopping%20editorial%20style%2C%20warm%20ivory%20and%20camel%20palette%2C%20clean%20organized%20composition&width=800&height=480&seq=seocard-v2-bargain&orientation=landscape',
  },
  {
    slug: 'nike-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Athletic%20sneakers%20in%20white%20and%20cream%20tones%20arranged%20on%20marble%20surface%2C%20soft%20natural%20studio%20lighting%2C%20modern%20sportswear%20product%20photography%2C%20clean%20athletic%20aesthetic%2C%20warm%20neutral%20palette%2C%20sophisticated%20minimalist%20composition%20with%20texture%20detail&width=800&height=480&seq=seocard-v2-nike&orientation=landscape',
  },
  {
    slug: 'beginner-tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20welcoming%20desk%20setup%20with%20open%20notebook%2C%20tablet%20and%20fashion%20catalog%20on%20light%20wood%20surface%2C%20morning%20sunlight%2C%20beginner-friendly%20educational%20lifestyle%20photography%2C%20soft%20cream%20and%20light%20oak%20tones%2C%20clean%20organized%20learning%20atmosphere&width=800&height=480&seq=seocard-v2-beginner&orientation=landscape',
  },
  {
    slug: 'power-user-hacks',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dual%20monitor%20desk%20setup%20with%20leather%20desk%20accessories%20and%20minimalist%20stationery%2C%20warm%20ambient%20lighting%2C%20sophisticated%20tech%20workspace%20photography%2C%20charcoal%20and%20cream%20tones%2C%20modern%20productivity%20aesthetic%20with%20depth%20of%20field&width=800&height=480&seq=seocard-v2-power&orientation=landscape',
  },
  {
    slug: 'best-shopping-research-tool',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20handbag%20and%20silk%20scarf%20artfully%20draped%20on%20marble%20platform%2C%20soft%20diffused%20gallery%20lighting%2C%20luxury%20retail%20editorial%20photography%2C%20warm%20champagne%20and%20ivory%20tones%2C%20sophisticated%20minimalist%20composition%20with%20elegant%20negative%20space&width=800&height=480&seq=seocard-v2-best-tool&orientation=landscape',
  },
  {
    slug: 'usa-shopping-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Denim%20jacket%2C%20canvas%20sneakers%20and%20leather%20backpack%20on%20rustic%20wooden%20surface%2C%20warm%20afternoon%20sunlight%20streaming%20through%20window%2C%20authentic%20Americana%20lifestyle%20photography%2C%20cream%20and%20indigo%20tones%2C%20editorial%20casual%20fashion%20composition&width=800&height=480&seq=seocard-v2-usa&orientation=landscape',
  },
  {
    slug: 'how-updates-work',
    imageUrl: 'https://readdy.ai/api/search-image?query=Color-coded%20folders%20with%20product%20swatches%20and%20planning%20board%20on%20creative%20workspace%2C%20soft%20natural%20skylight%2C%20behind-the-scenes%20organized%20photography%2C%20sage%20green%20and%20cream%20tones%2C%20productive%20creative%20atmosphere%20with%20artistic%20details&width=800&height=480&seq=seocard-v2-updates&orientation=landscape',
  },
];

export default function SEOSection() {
  const displayCards = allArticles.slice(0, 10);

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-xs font-label font-semibold uppercase tracking-wider text-accent-500 mb-3">
            Shopping Intelligence
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            Everything You Need to Know About<br />
            Hipobuy Spreadsheet
          </h2>
          <p className="mt-4 text-sm md:text-base font-body text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Deep-dive guides covering the complete Hipobuy Spreadsheet ecosystem — from comparison analyses and beginner tutorials to advanced power-user techniques and category-specific strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {displayCards.slice(0, 6).map((card, idx) => {
            const cardImage = articleCards[idx];
            return (
              <Link
                key={card.slug}
                to={`/article/${card.slug}`}
                className="group flex flex-col bg-background-100 rounded-lg overflow-hidden hover:translate-y-[-4px] transition-transform duration-300"
              >
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <img
                    src={cardImage?.imageUrl || card.heroImageUrl}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-label font-medium rounded-full">
                      Guide
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                    {card.title}
                  </h3>
                  <p className="text-sm font-body text-foreground-600 leading-relaxed flex-1">
                    {card.summary}
                  </p>
                  <div className="mt-4 pt-3 border-t border-background-200/70">
                    <span className="inline-flex items-center gap-1 text-xs font-label font-semibold text-primary-500 whitespace-nowrap">
                      Read Full Guide
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        {displayCards.length > 6 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto mt-5 md:mt-6">
            {displayCards.slice(6, 10).map((card, idx) => {
              const cardImage = articleCards[idx + 6];
              return (
                <Link
                  key={card.slug}
                  to={`/article/${card.slug}`}
                  className="group flex flex-col bg-background-100 rounded-lg overflow-hidden hover:translate-y-[-4px] transition-transform duration-300"
                >
                  <div className="relative h-36 md:h-40 overflow-hidden">
                    <img
                      src={cardImage?.imageUrl || card.heroImageUrl}
                      alt={card.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2.5 left-2.5">
                      <span className="px-2 py-0.5 bg-secondary-500/90 text-white text-xs font-label font-medium rounded-full">
                        Article
                      </span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5 flex flex-col flex-1">
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 leading-snug mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {card.title}
                    </h3>
                    <p className="text-xs md:text-sm font-body text-foreground-600 leading-relaxed flex-1 line-clamp-2">
                      {card.summary}
                    </p>
                    <div className="mt-3 pt-2 border-t border-background-200/70">
                      <span className="inline-flex items-center gap-1 text-xs font-label font-semibold text-primary-500 whitespace-nowrap">
                        Read Article
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}